export const GET_SAVED_PRODUCTS = 'GET_SAVED_PRODUCTS';
export const GET_SAVED_PRODUCTS_FAIL = 'GET_SAVED_PRODUCTS_FAIL';
export const GET_SAVED_PRODUCTS_SUCCESS = 'GET_SAVED_PRODUCTS_SUCCESS';
export const LOAD_READY_PRODUCTS = 'LOAD_READY_PRODUCTS';
export const LOAD_READY_PRODUCTS_FAIL = 'LOAD_READY_PRODUCTS_FAIL';
export const LOAD_READY_PRODUCTS_SUCCESS = 'LOAD_READY_PRODUCTS_SUCCESS';
export const SAVE_READY_PRODUCTS = 'SAVE_READY_PRODUCTS';
export const SAVE_READY_PRODUCTS_SUCCESS = 'SAVE_READY_PRODUCTS_SUCCESS';
export const SAVE_READY_PRODUCTS_FAIL = 'SAVE_READY_PRODUCTS_FAIL';
export const GET_READY_PRODUCTS_CLEAR = 'GET_READY_PRODUCTS_CLEAR';
export const SET_SAVED_RESPONSE = 'SET_SAVE_RESPONSE';
export const SET_MARK = 'SET_MARK';
export const SET_LENGTH = 'SET_LENGTH';
export const SET_NORMATIVE_DOC = 'SET_NORMATIVE_DOC';
export const SET_OPERATION_NUM_ID = 'SET_OPERATION_NUM_ID';
export const SET_OPERATION_TYPE = 'SET_OPERATION_TYPE';
export const SET_PIECE_ID = 'SET_PIECE_ID';
export const SET_PIECE_NUM_ID = 'SET_PIECE_NUM_ID';
export const SET_PROFILE_SIZE = 'SET_PROFILE_SIZE';
export const SET_QC_DATE = 'SET_QC_DATE';
export const SET_QC_ID = 'SET_QC_ID';
export const SET_QTY = 'SET_QTY';
export const SET_THICKNESS = 'SET_THICKNESS';
export const SET_SAVED_QUANTITY = 'SET_SAVED_QUANTITY';
export const SET_SAVED_QUANTITY_OFF = 'SET_SAVED_QUANTITY_OFF';
export const SET_ZDVL_LINE_ID = 'SET_ZDVL_LINE_ID';
export const SET_ZDVL_LINE_NUM_ID = 'SET_ZDVL_LINE_NUM_ID';
export const SET_UNIT = 'SET_UNIT';
export const GET_READY_PRODUCTS_SUCCESS = 'GET_READY_PRODUCTS_SUCCESS';
export const GET_READY_PRODUCTS_FAIL = 'GET_READY_PRODUCTS_FAIL';
export const GET_READY_BY_SEMI = 'GET_READY_BY_SEMI';
export const GET_READY_BY_SEMI_SUCCESS = 'GET_READY_BY_SEMI_SUCCESS';
export const GET_READY_BY_SEMI_FAIL = 'GET_READY_BY_SEMI_FAIL';
export const SET_READY_PRODUCTS_PIECES = 'SET_READY_PRODUCTS_PIECES';
export const SET_CAPACITY_PIPE = 'SET_CAPACITY_PIPE';
export const SET_CAPACITY_AVAILABLE = 'SET_CAPACITY_AVAILABLE';
export const SET_ATTRIBS_INHERIT = 'SET_ATTRIBS_INHERIT';

export const GET_ZDVL_BY_TASK = 'GET_ZDVL_BY_TASK';
export const GET_ZDVL_BY_TASK_SUCCESS = 'GET_ZDVL_BY_TASK_SUCCESS';
export const GET_ZDVL_BY_TASK_FAIL = 'GET_ZDVL_BY_TASK_FAIL';

export const SET_SAVE_REQUEST = 'SET_SAVE_REQUEST'
